import { render, staticRenderFns } from "./StockTrendList.vue?vue&type=template&id=1a7030a9&scoped=true"
import script from "./StockTrendList.vue?vue&type=script&lang=js"
export * from "./StockTrendList.vue?vue&type=script&lang=js"
import style0 from "./StockTrendList.vue?vue&type=style&index=0&id=1a7030a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7030a9",
  null
  
)

export default component.exports